import { ViewQuestion } from '@/surveys/ViewQuestion';
import { Dictionary, groupBy, map, sortBy } from 'lodash';
import { State } from './State';

type CategorizedQuestions = Array<{ name: string; questions: ViewQuestion[] }>;

const safeObjectKeys = (object: {} | undefined | null) => {
  if (!object) {
    return [];
  }
  return Object.keys(object);
};

export const getters = {
  questionsInCategories: (state: State): CategorizedQuestions => {
    if (!state.survey) {
      return [];
    }

    const orderedQuestions = sortBy(
      map(state.survey.questions, (value, id) => ({ ...value, id })),
      'order',
    );
    const questionsByCategory = categorizeQuestions(orderedQuestions);
    return createCategoryList(questionsByCategory);
  },
  datapointsWithoutQuestionTypes: (state: State): string[] =>
    safeObjectKeys(state.unmappedQuestionTypes),
  questionLabelsWithoutDatapoints: (state: State): string[] =>
    safeObjectKeys(state.unmappedDatapoints),
};

const categorizeQuestions = (
  questions: ViewQuestion[],
): Dictionary<ViewQuestion[]> => groupBy(questions, (value) => value.category);

const createCategoryList = (
  questionsByCategory: Dictionary<ViewQuestion[]>,
): CategorizedQuestions =>
  map(questionsByCategory, (value, key) => ({ name: key, questions: value }));
